export const altGaming = {
  jiliGaming: {
    FortuneGems: {
      code: "",
      casino: "JiLi Gaming",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Gems",
      name: "Fortune Gems",
      providerName: "JiLi Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortunegems.jpg",
      redirectUrl: "/casino/aggapjiligaming-fortune-gems",
    },
    ColorPrediction: {
      code: "",
      casino: "JiLi Gaming",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Color Prediction",
      name: "Color Prediction",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/ColorPrediction.webp",
      redirectUrl: "/casino/aggapjiligaming-color-prediction",
    },
    PirateQueen: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pirate Queen",
      name: "Pirate Queen",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Piratequeen.jpg",
      redirectUrl: "/casino/aggapjiligaming-pirate-queen",
    },
    WildRacer: {
      code: "56768",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Racer",
      name: "Wild Racer",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Wildracer.jpg",
      redirectUrl: "/casino/aggapjiligaming-wild-racer",
    },
    NekoFortune: {
      code: "98790",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Neko Fortune",
      name: "Neko Fortune",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/nekofortune.jpg",
      redirectUrl: "/casino/aggapjiligaming-neko-fortune",
    },
    Samba: {
      code: "98789",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Samba",
      name: "Samba",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/samba.jpg",
      redirectUrl: "/casino/aggapjiligaming-samba",
    },
    WorldCup: {
      code: "56968",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "World Cup",
      name: "World Cup",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/worldcup.jpg",
      redirectUrl: "/casino/aggapjiligaming-world-cup",
    },
    BonusHunter: {
      code: "67660",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bonus Hunter",
      name: "Bonus Hunter",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/bonushunter.jpg",
      redirectUrl: "/casino/aggapjiligaming-bonus-hunter",
    },
    JILICAISHEN: {
      code: "67580",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "JILI CAISHEN",
      name: "JILI CAISHEN",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jilicaishen.jpg",
      redirectUrl: "/casino/aggapjiligaming-jili-caishen",
    },
    MayanEmpire: {
      code: "67600",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mayan Empire",
      name: "Mayan Empire",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Mayanempire.webp",
      redirectUrl: "/casino/aggapjiligaming-mayan-empire",
    },
    BoneFortune: {
      code: "87564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bone Fortune",
      name: "Bone Fortune",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/bonefortune.webp",
      redirectUrl: "/casino/aggapjiligaming-bone-fortune",
    },
    GoldRush: {
      code: "67620",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Gold Rush",
      name: "Gold Rush",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Goldrush.webp",
      redirectUrl: "/casino/aggapjiligaming-gold-rush",
    },
    HappyTaxi: {
      code: "67567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Happy Taxi",
      name: "Happy Taxi",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/happytaxi.jpg",
      redirectUrl: "/casino/aggapjiligaming-happy-taxi",
    },
    ThorX: {
      code: "67570",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Thor X",
      name: "Thor X",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/ThorX.jpg",
      redirectUrl: "/casino/aggapjiligaming-thor-x",
    },
    BookofGold: {
      code: "56767",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Book of Gold",
      name: "Book of Gold",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/bookofgold.jpg",
      redirectUrl: "/casino/aggapjiligaming-book-of-gold",
    },
    Medusa: {
      code: "98788",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Medusa",
      name: "Medusa",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/medusa.jpg",
      redirectUrl: "/casino/aggapjiligaming-medusa",
    },
    GoGoalBingo: {
      code: "98791",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Go Goal Bingo",
      name: "Go Goal Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/gogoalbingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-go-goal-bingo",
    },
    ColorGame: {
      code: "67630",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Color Game",
      name: "Color Game",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/ColorGame.webp",
      redirectUrl: "/casino/aggapjiligaming-color-game",
    },
    JackpotBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jackpot Bingo",
      name: "Jackpot Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jackpotbingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-jackpot-bingo",
    },
    LuckyBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Bingo",
      name: "Lucky Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/luckybingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-lucky-bingo",
    },
    WinDrop: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Win Drop",
      name: "Win Drop",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/windrop.jpg",
      redirectUrl: "/casino/aggapjiligaming-win-drop",
    },
    FortuneBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Bingo",
      name: "Fortune Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortunebingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-fortune-bingo",
    },
    Baccarat: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat",
      name: "Baccarat",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/baccarat.jpg",
      redirectUrl: "/casino/aggapjiligaming-baccarat",
    },
    iRichBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "iRich Bingo",
      name: "iRich Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/iRichBingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-irich-bingo",
    },

    GoldenJoker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Golden Joker",
      name: "Golden Joker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/goldenjoker.jpg",
      redirectUrl: "/casino/aggapjiligaming-golden-joker",
    },
    MasterTiger: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Master Tiger",
      name: "Master Tiger",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/mastertiger.jpg",
      redirectUrl: "/casino/aggapjiligaming-master-tiger",
    },
    WildAce: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Ace",
      name: "Wild Ace",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/WildAce.webp",
      redirectUrl: "/casino/aggapjiligaming-wild-ace",
    },
    Crazy777: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crazy 777",
      name: "Crazy 777",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Crazy777.jpg",
      redirectUrl: "/casino/aggapjiligaming-crazy777",
    },
    dominogo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Domino Go",
      name: "Domino Go",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/dominogo.webp",
      redirectUrl: "/casino/aggapjiligaming-domino-go",
    },
    ultimatetexasholdem: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ultimate Texas Hold'em",
      name: "Ultimate Texas Hold'em",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_ultimate_texas_holdem.png",
      redirectUrl: "/casino/aggapjiligaming-ultimate-texas-holdem",
    },
    jili_keno_nonus_number: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Keno Bonus Number",
      name: "Keno Bonus Number",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_keno_nonus_number.png",
      redirectUrl: "/casino/aggapjiligaming-keno-bonus-number",
    },
    jili_crash_cricket: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crash Cricket",
      name: "Crash Cricket",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_crash_cricket.png",
      redirectUrl: "/casino/aggapjiligaming-crash-cricket",
    },
    jili_crash_goal: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crash Goal",
      name: "Crash Goal",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_crash_goal.png",
      redirectUrl: "/casino/aggapjiligaming-crash-goal",
    },
    jili_fortune_roulette: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Roulette",
      name: "Fortune Roulette",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_fortune_roulette.png",
      redirectUrl: "/casino/aggapjiligaming-fortune-roulette",
    },
    jili_cricket_roulettte: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricket Roulette",
      name: "Cricket Roulette",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_cricket_roulettte.png",
      redirectUrl: "/casino/aggapjiligaming-cricket-roulette",
    },
    jili_super_esabong: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super E-Sabong",
      name: "Super E-Sabong",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_super_esabong.png",
      redirectUrl: "/casino/aggapjiligaming-super-e-sabong",
    },
    jili_thai_hilo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Thai Hilo",
      name: "Thai Hilo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_thai_hilo.png",
      redirectUrl: "/casino/aggapjiligaming-thai-hilo",
    },
    jili_boxing_extravaganza: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Boxing Extravaganza",
      name: "Boxing Extravaganza",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_boxing_extravaganza.png",
      redirectUrl: "/casino/aggapjiligaming-boxing-extravaganza",
    },
    jili_jhandi_munda: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jhandi Munda",
      name: "Jhandi Munda",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_jhandi_munda.png",
      redirectUrl: "/casino/aggapjiligaming-jhandi-munda",
    },
    jili_super_ace_scratch: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Ace Scratch",
      name: "Super Ace Scratch",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_super_ace_scratch.png",
      redirectUrl: "/casino/aggapjiligaming-super-ace-scratch",
    },
    jili_fish_prawn_crab: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fish Prawn Crab",
      name: "Fish Prawn Crab",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_fish_prawn_crab.png",
      redirectUrl: "/casino/aggapjiligaming-fish-prawn-crab",
    },
    jili_lucky_jaguar: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Jaguar",
      name: "Lucky Jaguar",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_lucky_jaguar.png",
      redirectUrl: "/casino/aggapjiligaming-lucky-jaguar",
    },
    jili_shogun: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Shōgun",
      name: "Shōgun",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_shogun.png",
      redirectUrl: "/casino/aggapjiligaming-shogun",
    },
    jili_nightfall_hunting: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Nightfall Hunting",
      name: "Nightfall Hunting",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_nightfall_hunting.png",
      redirectUrl: "/casino/aggapjiligaming-nightfall-hunting",
    },
    jili_money_pot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Money Pot",
      name: "Money Pot",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_money_pot.png",
      redirectUrl: "/casino/aggapjiligaming-money-pot",
    },
    jili_3_pot_dragons: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Pot Dragons",
      name: "3 Pot Dragons",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_3_pot_dragons.png",
      redirectUrl: "/casino/aggapjiligaming-3-pot-dragons",
    },
    jili_poseidon: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poseidon",
      name: "Poseidon",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_poseidon.png",
      redirectUrl: "/casino/aggapjiligaming-poseidon",
    },
    jili_3_lucky_piggy: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Lucky Piggy",
      name: "3 Lucky Piggy",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_3_lucky_piggy.png",
      redirectUrl: "/casino/aggapjiligaming-3-lucky-piggy",
    },
    jili_egypts_glow: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Egypt's Glow",
      name: "Egypt's Glow",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_egypts_glow.png",
      redirectUrl: "/casino/aggapjiligaming-egypts-glow",
    },
    jili_party_star: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Party Star",
      name: "Party Star",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_party_star.png",
      redirectUrl: "/casino/aggapjiligaming-party-star",
    },
    jili_money_coming_expand_bets: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Money Coming Expand Bets",
      name: "Money Coming Expand Bets",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_money_coming_expand_bets.png",
      redirectUrl: "/casino/aggapjiligaming-money-coming-expand-bets",
    },
    jili_super_ace_deluxe: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Ace Deluxe",
      name: "Super Ace Deluxe",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_super_ace_deluxe.png",
      redirectUrl: "/casino/aggapjiligaming-super-ace-deluxe",
    },
    jili_legacy_of_egypt: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Legacy of Egypt",
      name: "Legacy of Egypt",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_legacy_of_egypt.png",
      redirectUrl: "/casino/aggapjiligaming-legacy-of-egypt",
    },
    jili_the_pig_house: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "The Pig House",
      name: "The Pig House",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_the_pig_house.png",
      redirectUrl: "/casino/aggapjiligaming-the-pig-house",
    },
    jili_crazy_hunter_2: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crazy Hunter 2",
      name: "Crazy Hunter 2",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_crazy_hunter_2.png",
      redirectUrl: "/casino/aggapjiligaming-crazy-hunter-2",
    },
    jili_fortune_king_jackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune King Jackpot",
      name: "Fortune King Jackpot",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_fortune_king_jackpot.png",
      redirectUrl: "/casino/aggapjiligaming-fortune-king-jackpot",
    },
    video_poker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Video Poker",
      name: "Video Poker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/video_poker.webp",
      redirectUrl: "/casino/aggapjiligaming-video-poker",
    },
    caribbean_stud_poker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Caribbean Stud Poker",
      name: "Caribbean Stud Poker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/caribbean_stud_poker.webp",
      redirectUrl: "/casino/aggapjiligaming-caribbean-stud-poker",
    },
    pool_rummy: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pool Rummy",
      name: "Pool Rummy",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/pool_rummy.webp",
      redirectUrl: "/casino/aggapjiligaming-pool-rummy",
    },
    mini_flush: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "MINI FLUSH",
      name: "MINI FLUSH",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/mini_flush.webp",
      redirectUrl: "/casino/aggapjiligaming-mini-flush",
    },
    blackjack_lucky_ladies: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack Lucky Ladies",
      name: "Blackjack Lucky Ladies",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/blackjack_lucky_ladies.webp",
      redirectUrl: "/casino/aggapjiligaming-blackjack-lucky-ladies",
    },
    blackjack: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack",
      name: "Blackjack",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/blackjack.webp",
      redirectUrl: "/casino/aggapjiligaming-blackjack",
    },
    crash_bonus: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crash Bonus",
      name: "Crash Bonus",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/crash_bonus.webp",
      redirectUrl: "/casino/aggapjiligaming-crash-bonus",
    },
    plinko: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Plinko",
      name: "Plinko",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/plinko.webp",
      redirectUrl: "/casino/aggapjiligaming-plinko",
    },
    keno: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Keno",
      name: "Keno",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/keno.webp",
      redirectUrl: "/casino/aggapjiligaming-keno",
    },
    mines_gold: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mines Gold",
      name: "Mines Gold",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/mines_gold.webp",
      redirectUrl: "/casino/aggapjiligaming-mines-gold",
    },
    speed_baccarat: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Speed Baccarat",
      name: "Speed Baccarat",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/speed_baccarat.webp",
      redirectUrl: "/casino/aggapjiligaming-speed-baccarat",
    },
    jogo_do_bicho: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jogo do Bicho",
      name: "Jogo do Bicho",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jogo_do_bicho.webp",
      redirectUrl: "/casino/aggapjiligaming-jogo-do-bicho",
    },
    european_roulette: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "European Roulette",
      name: "European Roulette",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/european_roulette.webp",
      redirectUrl: "/casino/aggapjiligaming-european-roulette",
    },
    pearls_of_bingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pearls of Bingo",
      name: "Pearls of Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/pearls_of_bingo.webp",
      redirectUrl: "/casino/aggapjiligaming-pearls-of-bingo",
    },
    magiclamp_bingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Magic Lamp Bingo",
      name: "Magic Lamp Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/magiclamp_bingo.webp",
      redirectUrl: "/casino/aggapjiligaming-magic-lamp-bingo",
    },
    color_prediction: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Color Prediction",
      name: "Color Prediction",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/color_prediction.webp",
      redirectUrl: "/casino/aggapjiligaming-color-prediction",
    },
    candyland_bingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Candyland Bingo",
      name: "Candyland Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/candyland_bingo.webp",
      redirectUrl: "/casino/aggapjiligaming-candyland-bingo",
    },
    potion_wizard: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Potion Wizard",
      name: "Potion Wizard",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/potion_wizard.webp",
      redirectUrl: "/casino/aggapjiligaming-potion-wizard",
    },
    coin_treasures3: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Coin Treasures",
      name: "3 Coin Treasures",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/3_coin_treasures.webp",
      redirectUrl: "/casino/aggapjiligaming-3-coin-treasures",
    },
    fortune_gems_3: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Gems 3",
      name: "Fortune Gems 3",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortune_gems_3.webp",
      redirectUrl: "/casino/aggapjiligaming-fortune-gems-3",
    },
    jackpot_joker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jackpot Joker",
      name: "Jackpot Joker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jackpot_joker.webp",
      redirectUrl: "/casino/aggapjiligaming-jackpot-joker",
    },
    zeus: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Zeus",
      name: "Zeus",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/zeus.webp",
      redirectUrl: "/casino/aggapjiligaming-zeus",
    },
    devil_fire_2: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Devil Fire 2",
      name: "Devil Fire 2",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/devil_fire_2.webp",
      redirectUrl: "/casino/aggapjiligaming-devil-fire-2",
    },
    trial_of_phoenix: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Trial of Phoenix",
      name: "Trial of Phoenix",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/trial_of_phoenix.webp",
      redirectUrl: "/casino/aggapjiligaming-trial-of-phoenix",
    },
    arena_fighter: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Arena Fighter",
      name: "Arena Fighter",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/arena_fighter.webp",
      redirectUrl: "/casino/aggapjiligaming-arena-fighter",
    },
    witches_night: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Witches Night",
      name: "Witches Night",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/witches_night.webp",
      redirectUrl: "/casino/aggapjiligaming-witches-night",
    },
    charge_buffalo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Charge Buffalo Ascent",
      name: "Charge Buffalo Ascent",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/charge_buffalo.webp",
      redirectUrl: "/casino/aggapjiligaming-charge-buffalo-ascent",
    },
    king_arthur: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "King Arthur",
      name: "King Arthur",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/king_arthur.webp",
      redirectUrl: "/casino/aggapjiligaming-king-arthur",
    },
    sin_city: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sin City",
      name: "Sin City",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/sin_city.webp",
      redirectUrl: "/casino/aggapjiligaming-sin-city",
    },
    dabangg: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dabanggg",
      name: "Dabanggg",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/dabangg.webp",
      redirectUrl: "/casino/aggapjiligaming-dabanggg",
    },
    fortune_monkey: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Monkey",
      name: "Fortune Monkey",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortune_monkey.webp",
      redirectUrl: "/casino/aggapjiligaming-fortune-monkey",
    },
    aztec_priestess: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Aztec Priestess",
      name: "Aztec Priestess",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/aztec_priestess.webp",
      redirectUrl: "/casino/aggapjiligaming-aztec-priestess",
    },
    bangla_beauty: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bangla Beauty",
      name: "Bangla Beauty",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/bangla_beauty.webp",
      redirectUrl: "/casino/aggapjiligaming-bangla-beauty",
    },
    devil_fire: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Devil Fire",
      name: "Devil Fire",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/devil_fire.webp",
      redirectUrl: "/casino/aggapjiligaming-devil-fire",
    },
    golden_temple: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Golden Temple",
      name: "Golden Temple",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/golden_temple.webp",
      redirectUrl: "/casino/aggapjiligaming-golden-temple",
    },
    cricket_sah_75: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricket Sah 75",
      name: "Cricket Sah 75",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/cricket_sah_75.webp",
      redirectUrl: "/casino/aggapjiligaming-cricket-sah-75",
    },
    elf_bingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Elf Bingo",
      name: "Elf Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/elf_bingo.webp",
      redirectUrl: "/casino/aggapjiligaming-elf-bingo",
    },
    cricket_king_18: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricket King 18",
      name: "Cricket King 18",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/cricket_king_18.webp",
      redirectUrl: "/casino/aggapjiligaming-cricket-king-18",
    },
    sweet_land: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sweet Land",
      name: "Sweet Land",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/sweet_land.webp",
      redirectUrl: "/casino/aggapjiligaming-sweet-land",
    },
    fortune_gems_2: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Gems 2",
      name: "Fortune Gems 2",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortune_gems_2.webp",
      redirectUrl: "/casino/aggapjiligaming-fortune-gems-2",
    },
    diamond_city: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "DiamondParty",
      name: "DiamondParty",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/diamondparty.webp",
      redirectUrl: "/casino/aggapjiligaming-diamondparty",
    },
    night_city: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Night City",
      name: "Night City",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/nightcity.webp",
      redirectUrl: "/casino/aggapjiligaming-night-city",
    },
    hawaii_beauty: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hawaii Beauty",
      name: "Hawaii Beauty",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/hawaibeauty.webp",
      redirectUrl: "/casino/aggapjiligaming-hawaii-beauty",
    },
    ocean_king_jackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ocean King Jackpot",
      name: "Ocean King Jackpot",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/oceankingjackpot.webp",
      redirectUrl: "/casino/aggapjiligaming-ocean-king-jackpot",
    },
    jili_pusoy_go: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pusoy Go",
      name: "Pusoy Go",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/pusoygo.webp",
      redirectUrl: "/casino/aggapjiligaming-pusoy-go",
    },
    jili_tongits_go: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tongits Go",
      name: "Tongits Go",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/tongitsgo.webp",
      redirectUrl: "/casino/aggapjiligaming-tongits-go",
    },
    jili_ludo_quick: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ludo Quick",
      name: "Ludo Quick",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/ludoquick.webp",
      redirectUrl: "/casino/aggapjiligaming-ludo-quick",
    },
    jili_teenpatti_2020: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "TeenPatti 20-20",
      name: "TeenPatti 20-20",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/teenpatti2020.webp",
      redirectUrl: "/casino/aggapjiligaming-teenpatti-20-20",
    },
    jili_callbreak_quick: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Callbreak Quick",
      name: "Callbreak Quick",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/callbreakquick.webp",
      redirectUrl: "/casino/aggapjiligaming-callbreak-quick",
    },
    jili_teenpatti_joker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "TeenPatti Joker",
      name: "TeenPatti Joker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/teenpattijocker.webp",
      redirectUrl: "/casino/aggapjiligaming-teenpatti-joker",
    },
    jili_callbreak: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Callbreak",
      name: "Callbreak",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/CallBreak.webp",
      redirectUrl: "/casino/aggapjiligaming-callbreak",
    },
    jili_wheel: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wheel",
      name: "Wheel",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Wheel.webp",
      redirectUrl: "/casino/aggapjiligaming-wheel",
    },
    jili_limbo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Limbo",
      name: "Limbo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_limbo.webp",
      redirectUrl: "/casino/aggapjiligaming-limbo",
    },
    jili_golden_land: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Golden Land",
      name: "Golden Land",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_golden_land.webp",
      redirectUrl: "/casino/aggapjiligaming-golden-land",
    },
    jili_bingo_adventure: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bingo Adventure",
      name: "Bingo Adventure",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_bingo_adventure.webp",
      redirectUrl: "/casino/aggapjiligaming-bingo-adventure",
    },
    jili_hilo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "HILO",
      name: "HILO",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/hilo.webp",
      redirectUrl: "/casino/aggapjiligaming-hilo",
    },
    jili_tower: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tower",
      name: "Tower",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Tower.webp",
      redirectUrl: "/casino/aggapjiligaming-tower",
    },
    jili_mines: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mines",
      name: "Mines",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/mines.webp",
      redirectUrl: "/casino/aggapjiligaming-mines",
    },
    jili_go_rush: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Go Rush",
      name: "Go Rush",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/GoRush.webp",
      redirectUrl: "/casino/aggapjiligaming-go-rush",
    },
    jili_west_hunter_bingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "West Hunter Bingo",
      name: "West Hunter Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Westhunterbingogolden.webp",
      redirectUrl: "/casino/aggapjiligaming-west-hunter-bingo",
    },
    jili_pappu: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "PAPPU",
      name: "PAPPU",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Pappu.webp",
      redirectUrl: "/casino/aggapjiligaming-pappu",
    },
    jili_calaca_bingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Calaca Bingo",
      name: "Calaca Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Calacabingo.webp",
      redirectUrl: "/casino/aggapjiligaming-calaca-bingo",
    },

    jili_win_drop: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Win Drop",
      name: "Win Drop",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/WinDrop.webp",
      redirectUrl: "/casino/aggapjiligaming-win-drop",
    },
    jili_bingo_carnaval: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bingo Carnaval",
      name: "Bingo Carnaval",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/BingoCarnaval.webp",
      redirectUrl: "/casino/aggapjiligaming-bingo-carnaval",
    },
    jili_super_bingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Bingo",
      name: "Super Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/SuperBingo.webp",
      redirectUrl: "/casino/aggapjiligaming-super-bingo",
    },

    jili_big_small: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Big Small",
      name: "Big Small",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/BigSmall.webp",
      redirectUrl: "/casino/aggapjiligaming-big-small",
    },

    jili_crazy_pusher: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crazy Pusher",
      name: "Crazy Pusher",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/crazypusher.webp",
      redirectUrl: "/casino/aggapjiligaming-crazy-pusher",
    },

    jili_mega_ace: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mega Ace",
      name: "Mega Ace",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/MegaAce.webp",
      redirectUrl: "/casino/aggapjiligaming-mega-ace",
    },
    jili_dinosaur_tycoon_II: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dinosaur Tycoon II",
      name: "Dinosaur Tycoon II",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/DinosaurTycoon.webp",
      redirectUrl: "/casino/aggapjiligaming-dinosaur-tycoon-ii",
    },
    jili_sicbo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sic Bo",
      name: "Sic Bo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Sicbo.webp",
      redirectUrl: "/casino/aggapjiligaming-sic-bo",
    },
    jili_7up7down: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "7up7down",
      name: "7up7down",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/7up7Down.webp",
      redirectUrl: "/casino/aggapjiligaming-7up7down",
    },
    Jili_Journey_West_M: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Journey West M",
      name: "Journey West M",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/journeywestM.webp",
      redirectUrl: "/casino/aggapjiligaming-journey-west-m",
    },
    Jili_Ali_Baba: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ali Baba",
      name: "Ali Baba",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/alibaba.webp",
      redirectUrl: "/casino/aggapjiligaming-ali-baba",
    },
    Jili_Twin_Wins: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "TWIN WINS",
      name: "TWIN WINS",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/twinwins.webp",
      redirectUrl: "/casino/aggapjiligaming-twin-wins",
    },
    Jili_Agent_Ace: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Agent Ace",
      name: "Agent Ace",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/agentace.webp",
      redirectUrl: "/casino/aggapjiligaming-agent-ace",
    },
    Jili_Magic_Lamp: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Magic Lamp",
      name: "Magic Lamp",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/magiclamb.webp",
      redirectUrl: "/casino/aggapjiligaming-magic-lamp",
    },
    Jili_Party_Night: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Party Night",
      name: "Party Night",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/partynight.webp",
      redirectUrl: "/casino/aggapjiligaming-party-night",
    },
    Jili_Crazy_Hunter: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crazy Hunter",
      name: "Crazy Hunter",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/crazyhunter.webp",
      redirectUrl: "/casino/aggapjiligaming-crazy-hunter",
    },
    Jili_All_Star_Fishing: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "All-star Fishing",
      name: "All-star Fishing",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/allstarfishing.webp",
      redirectUrl: "/casino/aggapjiligaming-all-star-fishing",
    },
    Jili_Golden_Empire: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Golden Empire",
      name: "Golden Empire",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Goldenempire.webp",
      redirectUrl: "/casino/aggapjiligaming-golden-empire",
    },
    Jili_Roma_X: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "RomaX",
      name: "RomaX",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/RomaX.webp",
      redirectUrl: "/casino/aggapjiligaming-romax",
    },
    Jili_Super_Rich: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Rich",
      name: "Super Rich",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/SuperRich.webp",
      redirectUrl: "/casino/aggapjiligaming-super-rich",
    },
    Jili_Lucky_Coming: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Coming",
      name: "Lucky Coming",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/luckycoming.webp",
      redirectUrl: "/casino/aggapjiligaming-lucky-coming",
    },
    Jili_Pharaoh_Treasure: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pharaoh Treasure",
      name: "Pharaoh Treasure",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/pharaohtreasure.webp",
      redirectUrl: "/casino/aggapjiligaming-pharaoh-treasure",
    },
    Jili_Secret_Treasure: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Secret Treasure",
      name: "Secret Treasure",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Secreatetreasure.webp",
      redirectUrl: "/casino/aggapjiligaming-secret-treasure",
    },
    Jili_Boxing_King: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Boxing King",
      name: "Boxing King",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/BoxingKing.webp",
      redirectUrl: "/casino/aggapjiligaming-boxing-king",
    },
    Jili_Jungle_King: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jungle King",
      name: "Jungle King",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Jungleking.webp",
      redirectUrl: "/casino/aggapjiligaming-jungle-king",
    },
    Jili_Money_Coming: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Money Coming",
      name: "Money Coming",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/MoneyComing.webp",
      redirectUrl: "/casino/aggapjiligaming-money-coming",
    },
    Jili_Monkey_Party: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Monkey Party",
      name: "Monkey Party",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/MonkeyParty.webp",
      redirectUrl: "/casino/aggapjiligaming-monkey-party",
    },
    Jili_Golden_Queen: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Golden Queen",
      name: "Golden Queen",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Goldenqueen.webp",
      redirectUrl: "/casino/aggapjiligaming-golden-queen",
    },
    Jili_Super_Ace: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Ace",
      name: "Super Ace",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/SuperAce.webp",
      redirectUrl: "/casino/aggapjiligaming-super-ace",
    },
    Jili_Charge_Buffalo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Charge Buffalo",
      name: "Charge Buffalo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/charge_buffalo.webp",
      redirectUrl: "/casino/aggapjiligaming-charge-buffalo",
    },
    Jili_Dragon_Treasure: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Treasure",
      name: "Dragon Treasure",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/dragontreasure.webp",
      redirectUrl: "/casino/aggapjiligaming-dragon-treasure",
    },
    Jili_Lucky_Goldbricks: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Goldbricks",
      name: "Lucky Goldbricks",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/luckygoldbricks.webp",
      redirectUrl: "/casino/aggapjiligaming-lucky-goldbricks",
    },
    Jili_Crazy_Golden_Bank: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crazy Golden Bank",
      name: "Crazy Golden Bank",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/CrazyGoldenBank.webp",
      redirectUrl: "/casino/aggapjiligaming-crazy-golden-bank",
    },

    Jili_Feng_Shen: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fengshen",
      name: "Fengshen",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/FengShen.webp",
      redirectUrl: "/casino/aggapjiligaming-fengshen",
    },
    Jili_Candy_Baby: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Candy Baby",
      name: "Candy Baby",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/candyBaby.webp",
      redirectUrl: "/casino/aggapjiligaming-candy-baby",
    },
    Jili_Fortune_Pig: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "FortunePig",
      name: "FortunePig",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/FortunePig.webp",
      redirectUrl: "/casino/aggapjiligaming-fortunepig",
    },
    Jili_Xiyangyang: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "XiYangYang",
      name: "XiYangYang",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Xiyangyang.webp",
      redirectUrl: "/casino/aggapjiligaming-xiyangyang",
    },
    Jili_Crazy_fafafa: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crazy FaFaFa",
      name: "Crazy FaFaFa",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Crazyfafafa.webp",
      redirectUrl: "/casino/aggapjiligaming-crazy-fafafa",
    },
    Jili_Bao_Boon_Chin: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bao boon chin",
      name: "Bao boon chin",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/BaoBoonChin.webp",
      redirectUrl: "/casino/aggapjiligaming-bao-boon-chin",
    },
    Jili_777: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "SevenSevenSeven",
      name: "SevenSevenSeven",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/SevenSevenSeven.webp",
      redirectUrl: "/casino/aggapjiligaming-sevensevenseven",
    },
    Jili_God_of_Martial: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "God Of Martial",
      name: "God Of Martial",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/GodofMartial.webp",
      redirectUrl: "/casino/aggapjiligaming-god-of-martial",
    },
    Jili_FaFaFa: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fa Fa Fa",
      name: "Fa Fa Fa",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Fafafa.webp",
      redirectUrl: "/casino/aggapjiligaming-fa-fa-fa",
    },
    Jili_Shanghai_Beauty: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Shanghai Beauty",
      name: "Shanghai Beauty",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/shanghaibeauty.webp",
      redirectUrl: "/casino/aggapjiligaming-shanghai-beauty",
    },
    Jili_Hyper_Burst: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hyper Burst",
      name: "Hyper Burst",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/HyperBurst.webp",
      redirectUrl: "/casino/aggapjiligaming-hyper-burst",
    },
    Jili_Lucky_Ball: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Ball",
      name: "Lucky Ball",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/LuckyBall.webp",
      redirectUrl: "/casino/aggapjiligaming-lucky-ball",
    },
    Jili_Fortune_Tree: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Tree",
      name: "Fortune Tree",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/FortuneTree.webp",
      redirectUrl: "/casino/aggapjiligaming-fortune-tree",
    },
    Jili_War_of_Drangons: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "War Of Dragons",
      name: "War Of Dragons",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/warofdragons.webp",
      redirectUrl: "/casino/aggapjiligaming-war-of-dragons",
    },
    Jili_Chin_Shj_Huang: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Chin Shi Huang",
      name: "Chin Shi Huang",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/chinshihuang.webp",
      redirectUrl: "/casino/aggapjiligaming-chin-shi-huang",
    },
    Jili_Hot_Chilli: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hot Chilli",
      name: "Hot Chilli",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Hotchilli.webp",
      redirectUrl: "/casino/aggapjiligaming-hot-chilli",
    },
    Jili_Gem_Party: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Gem Party",
      name: "Gem Party",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/GemParty.webp",
      redirectUrl: "/casino/aggapjiligaming-gem-party",
    },

    Jili_Number_King: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Number King",
      name: "Number King",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/numberking.webp",
      redirectUrl: "/casino/aggapjiligaming-number-king-u6989",
    },
    Jili_Rummy: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rummy",
      name: "Rummy",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Rummy.webp",
      redirectUrl: "/casino/aggapjiligaming-rummy-u7364",
    },
    Jili_Andar_Bahar: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Andar Bahar",
      name: "Andar Bahar",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/AndarBahar.webp",
      redirectUrl: "/casino/aggapjiligaming-andar-bahar-u6903",
    },
    Jili_AK47: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "AK47",
      name: "AK47",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/AK47.webp",
      redirectUrl: "/casino/aggapjiligaming-ak47-u2970",
    },
    Jili_Teen_Patti: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "TeenPatti",
      name: "TeenPatti",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Teenpatti.webp",
      redirectUrl: "/casino/aggapjiligaming-teenpatti-u7595",
    },
    Jili_Poker_King: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poker King",
      name: "Poker King",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/pokerking.webp",
      redirectUrl: "/casino/aggapjiligaming-poker-king",
    },
    Jili_Lucky_Number: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Number",
      name: "Lucky Number",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/LuckyNumber.webp",
      redirectUrl: "/casino/aggapjiligaming-lucky-number",
    },
    Jili_7_UpDown: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "7 UP-DOWN",
      name: "7 UP-DOWN",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/7UpDown.webp",
      redirectUrl: "/casino/aaggapjiligaming-7-up-down",
    },
    Jili_Dice: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dice",
      name: "Dice",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Dice.webp",
      redirectUrl: "/casino/aggapjiligaming-dice",
    },
    Jili_DragonTiger: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon & Tiger",
      name: "Dragon & Tiger",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/DragonandTiger.webp",
      redirectUrl: "/casino/aggapjiligaming-dragon-and-tiger",
    },
    Jili_Fairness_Games: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fairness Games",
      name: "Fairness Games",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/FairnessGames.webp",
      redirectUrl: "/casino/aggapjiligaming-fairness-games",
    },
    Jili_Happy_Fishing: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Happy Fishing",
      name: "Happy Fishing",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/happyFishing.webp",
      redirectUrl: "/casino/aggapjiligaming-happy-fishing",
    },
    Jili_Boom_Legend: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Boom Legend",
      name: "Boom Legend",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/BoomLegend.webp",
      redirectUrl: "/casino/aggapjiligaming-boom-legend",
    },
    Jili_Mega_Fishing: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mega Fishing",
      name: "Mega Fishing",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Megafishing.webp",
      redirectUrl: "/casino/aggapjiligaming-mega-fishing",
    },
    Jili_Dragon_Fortune: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Fortune",
      name: "Dragon Fortune",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/DragonFortune.webp",
      redirectUrl: "/casino/aggapjiligaming-dragon-fortune",
    },
    Jili_Jackpot_Fishing: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jackpot Fishing",
      name: "Jackpot Fishing",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/JackpotFishing.webp",
      redirectUrl: "/casino/aggapjiligaming-jackpot-fishing",
    },
    Jili_Dinosaur_Tycoon: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dinosaur Tycoon",
      name: "Dinosaur Tycoon",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/DinosaurTycoon.webp",
      redirectUrl: "/casino/aggapjiligaming-dinosaur-tycoon",
    },
    Jili_Bombing_Fishing: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bombing Fishing",
      name: "Bombing Fishing",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/BombingFishing.webp",
      redirectUrl: "/casino/aggapjiligaming-bombing-fishing",
    },
    Jili_Royal_Fishing: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Royal Fishing",
      name: "Royal Fishing",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/RoyalFishing.webp",
      redirectUrl: "/casino/aggapjiligaming-royal-fishing",
    },
  },
  mac88Gaming: {
    DragonTiger: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/DragonTiger.jpg",
      redirectUrl: "/casino/aggapmac88gaming-dragon-tiger",
    },
    DragonTiger1day: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "1 Day Dragon Tiger",
      name: "1 Day Dragon Tiger",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/DragonTiger1day.jpg",
      redirectUrl: "/casino/aggapmac88gaming-1-day-dragon-tiger",
    },
    Lucky7: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky 7",
      name: "Lucky 7",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/Lucky7.jpg",
      redirectUrl: "/casino/aggapmac88gaming-lucky7",
    },
    QueenRace: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Queen Race",
      name: "Queen Race",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/QueenRace.jpg",
      redirectUrl: "/casino/aggapmac88gaming-queen-race",
    },
    AmarAkbarAnthony: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Amar Akbar Anthony",
      name: "Amar Akbar Anthony",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/AmarAkbarAnthony.jpg",
      redirectUrl: "/casino/aggapmac88gaming-amar-akbar-anthony",
    },
    TeenPatti1Day: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Teenpatti One Day",
      name: "Teenpatti One Day",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/TeenPatti1Day.jpg",
      redirectUrl: "/casino/aggapmac88gaming-teenpatti-one-day",
    },
    RockPaperScissors: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rock Paper Scissors",
      name: "Rock Paper Scissors",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/rockpaperscissors.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-rock-paper-scissors",
    },
    Boys5: {
      code: "67720",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "5 Boys",
      name: "5 Boys",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/5boys.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-5-boys",
    },
    JetXT: {
      code: "92037",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jet XT",
      name: "Jet XT",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/jetxt.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-jet-xt",
    },
    Kitex: {
      code: "92038",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Kitex",
      name: "Kitex",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/kitex.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-kitex",
    },
    HiLo: {
      code: "67610",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hi Lo",
      name: "Hi Lo",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/hi-lo.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-hi-lo",
    },
    PushpaRani: {
      code: "67670",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pushpa Rani",
      name: "Pushpa Rani",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/pushparani.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-pushpa-rani",
    },
    BallbyBallVR: {
      code: "90100",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ball by Ball VR",
      name: "Ball by Ball VR",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/ballbyballvr.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-ball-by-ball-vr",
    },
    XRoulette: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "X Roulette",
      name: "X Roulette",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/xroulette.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-x-roulette",
    },
    Lucky15: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky 15",
      name: "Lucky 15",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/lucky15.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-lucky-15",
    },
    Vortex: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Vortex",
      name: "Vortex",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/vortex.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vortex",
    },
    BollyKiss: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bolly Kiss",
      name: "Bolly Kiss",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/bollykiss.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-bolly-kiss",
    },
    Plinko: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Plinko",
      name: "Plinko",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/plinko.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-plinko",
    },
    diamonds: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Diamond",
      name: "Diamond",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/diamonds.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-diamonds",
    },
    mines: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mines",
      name: "Mines",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/mines.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-mines",
    },
    Limbo: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Limbo",
      name: "Limbo",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/limbo.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-limbo",
    },
    CrashX: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crash X",
      name: "Crash X",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/crashx.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-crash-x",
    },
    Dice: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dice",
      name: "Dice",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/Dice.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-dice",
    },
    AK47VR: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "AK47 VR",
      name: "AK47 VR",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/ak47vr.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-ak47-vr",
    },
    KaunBanegaCrorepatiVR: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Kaun Banega Crorepati VR",
      name: "Kaun Banega Crorepati VR",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/kaunabanegacrorpativr.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-kaun-banega-crorepati-vr",
    },
    CenterCardVR: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Center Card VR",
      name: "Center Card VR",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/centrecard-vr.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-center-card-vr",
    },
    // HiloVR: {
    //   code: "67690",
    //   casino: "aura",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Hi Lo VR",
    //   name: "Hi Lo VR",
    //   providerName: "Mac88 Gaming Virtual",
    //   imgUrl: "./images/alt-gaming/mac88/centrecard-vr.jpg",
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-hi-lo-vr",
    // },
    // AviatorX2: {
    //   code: "67690",
    //   casino: "aura",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "AviatorX2",
    //   name: "AviatorX2",
    //   providerName: "Mac88 Gaming Virtual",
    //   imgUrl: "./images/alt-gaming/mac88/centrecard-vr.jpg",
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-aviatorx2",
    // },
    // K3Lottery10: {
    //   code: "67690",
    //   casino: "aura",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "K3 Lottery 10",
    //   name: "K3 Lottery 10",
    //   providerName: "Mac88 Gaming Virtual",
    //   imgUrl: "./images/alt-gaming/mac88/centrecard-vr.jpg",
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-k3-lottery-10",
    // },
  },
  pgsoftgames: {
      CashMania: {
        redirectUrl: "/casino/aggappg-cash-mania-u1195",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/Cashimania.webp",
        alt: "Cash Mania",
        name: "Cash Mania",
      },
      BaccaratDeluxe: {
        redirectUrl: "/casino/aggappg-baccarat-deluxe",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/baccaratdeluxe.webp",
        alt: "Baccarat Deluxe",
        name: "Baccarat Deluxe",
      },
      FortuneSnake: {
        redirectUrl: "/casino/aggappg-fortune-snake",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/fortunesnake.webp",
        alt: "Fortune Snake",
        name: "Fortune Snake",
      },
      GeishasRevenge: {
        redirectUrl: "/casino/aggappg-geishas-revenge",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/geishasrevenge.webp",
        alt: "Geisha's Revenge",
        name: "Geisha's Revenge",
      },
      ChocolateDeluxe: {
        redirectUrl: "/casino/aggappg-chocolate-deluxe",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/choclatedeluxe.webp",
        alt: "Chocolate Deluxe",
        name: "Chocolate Deluxe",
      },
      RioFantasia: {
        redirectUrl: "/casino/aggappg-rio-fantasia",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/riofantasia.webp",
        alt: "Rio Fantasia",
        name: "Rio Fantasia",
      },
      MuseumMystery: {
        redirectUrl: "/casino/aggappg-museum-mystery",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/museummystery.webp",
        alt: "Museum Mystery",
        name: "Museum Mystery",
      },
      OishiDelights: {
        redirectUrl: "/casino/aggappg-oishi-delights",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/oishidelights.webp",
        alt: "Oishi Delights",
        name: "Oishi Delights",
      },   
      threeCrazyPiggies: {
        redirectUrl: "/casino/aggappg-three-crazy-piggies",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/threecrazypiggies.webp",
        alt: "Three Crazy Piggies",
        name: "Three Crazy Piggies",
      },

      wingsOfIguazu: {
        redirectUrl: "/casino/aggappg-wings-of-iguazu",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/wingsoglguazu.webp",
        alt: "Wings of Iguazu",
        name: "Wings of Iguazu",
      },

      yakuzaHonor: {
        redirectUrl: "/casino/aggappg-yakuza-honor",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/yakuzahonor.webp",
        alt: "Yakuza Honor",
        name: "Yakuza Honor",
      },

      sharkBounty: {
        redirectUrl: "/casino/aggappg-shark-bounty",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/sharkbounty.webp",
        alt: "Shark Bounty",
        name: "Shark Bounty",
      },

      futebolFever: {
        redirectUrl: "/casino/aggappg-futebol-fever",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/fuetbolfever.webp",
        alt: "Futebol Fever",
        name: "Futebol Fever",
      },

      chickyRun: {
        redirectUrl: "/casino/aggappg-chicky-run",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/chickyrun.webp",
        alt: "Chicky Run",
        name: "Chicky Run",
      },

      zombieOutbreak: {
        redirectUrl: "/casino/aggappg-zombie-outbreak",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/zombieoutbreak.webp",
        alt: "Zombie Outbreak",
        name: "Zombie Outbreak",
      },

      anubisWrath: {
        redirectUrl: "/casino/aggappg-anubis-wrath",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/anubiswrath.webp",
        alt: "Anubis Wrath",
        name: "Anubis Wrath",
      },
      mysticPotion: {
        redirectUrl: "/casino/aggappg-mystic-potion",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/mysticpotion.webp",
        alt: "Mystic Potion",
        name: "Mystic Potion",
      },

      pinataWins: {
        redirectUrl: "/casino/aggappg-pinata-wins",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/pintawins.webp",
        alt: "Pinata Wins",
        name: "Pinata Wins",
      },

      wildApe3258: {
        redirectUrl: "/casino/aggappg-wild-ape-3258",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/wildApe.webp",
        alt: "Wild Ape #3258",
        name: "Wild Ape #3258",
      },

      cashMania: {
        redirectUrl: "/casino/aggappg-cash-mania",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/Cashimania.webp",
        alt: "Cash Mania",
        name: "Cash Mania",
      },

      gemstonesGold: {
        redirectUrl: "/casino/aggappg-gemstones-gold",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/genstonesgod.webp",
        alt: "Gemstones Gold",
        name: "Gemstones Gold",
      },

      fortuneDragon: {
        redirectUrl: "/casino/aggappg-fortune-dragon",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/fortunedragon.webp",
        alt: "Fortune Dragon",
        name: "Fortune Dragon",
      },

      dragonHatch2: {
        redirectUrl: "/casino/aggappg-dragon-hatch-2",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/dragonhatch2.webp",
        alt: "Dragon Hatch 2",
        name: "Dragon Hatch 2",
      },

      werewolfsHunt: {
        redirectUrl: "/casino/aggappg-werewolfs-hunt",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/werewolfshunt.webp",
        alt: "Werewolf's Hunt",
        name: "Werewolf's Hunt",
      },
      tsarTreasures: {
        redirectUrl: "/casino/aggappg-tsar-treasures",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/tasartreasure.webp",
        alt: "Tsar Treasures",
        name: "Tsar Treasures",
      },

      mafiaMayhem: {
        redirectUrl: "/casino/aggappg-mafia-mayhem",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/mafiamayhem.webp",
        alt: "Mafia Mayhem",
        name: "Mafia Mayhem",
      },

      forgeOfWealth: {
        redirectUrl: "/casino/aggappg-forge-of-wealth",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/forgeofwealth.webp",
        alt: "Forge of Wealth",
        name: "Forge of Wealth",
      },

      wildHeistCashout: {
        redirectUrl: "/casino/aggappg-wild-heist-cashout",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/wildheistcashout.webp",
        alt: "Wild Heist Cashout",
        name: "Wild Heist Cashout",
      },

      ultimateStriker: {
        redirectUrl: "/casino/aggappg-ultimate-striker",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/ultimatestriker.webp",
        alt: "Ultimate Striker",
        name: "Ultimate Striker",
      },

      ninjaRaccoonFrenzy: {
        redirectUrl: "/casino/aggappg-ninja-raccoon-frenzy",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/ninajracconfrenzy.webp",
        alt: "Ninja Raccoon Frenzy",
        name: "Ninja Raccoon Frenzy",
      },

      gladiatorsGlory: {
        redirectUrl: "/casino/aggappg-gladiators-glory",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/gladiatorsglory.webp",
        alt: "Gladiator's Glory",
        name: "Gladiator's Glory",
      },

      safariWilds: {
        redirectUrl: "/casino/aggappg-safari-wilds",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/safariwilds.webp",
        alt: "Safari Wilds",
        name: "Safari Wilds",
      },

      cruiseRoyale: {
        redirectUrl: "/casino/aggappg-cruise-royale",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/cruiseroyale.webp",
        alt: "Cruise Royale",
        name: "Cruise Royale",
      },

      fruityCandy: {
        redirectUrl: "/casino/aggappg-fruity-candy",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/fruitycandy.webp",
        alt: "Fruity Candy",
        name: "Fruity Candy",
      },

      luckyCloverLady: {
        redirectUrl: "/casino/aggappg-lucky-clover-lady",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/luckycloverlady.webp",
        alt: "Lucky Clover Lady",
        name: "Lucky Clover Lady",
      },

      superGolfDrive: {
        redirectUrl: "/casino/aggappg-super-golf-drive",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/supergolfdriver.webp",
        alt: "Super Golf Drive",
        name: "Super Golf Drive",
      },

      mysticalSpirits: {
        redirectUrl: "/casino/aggappg-mystical-spirits",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/mysticalspiritd.webp",
        alt: "Mystical Spirits",
        name: "Mystical Spirits",
      },

      songkranSplash: {
        redirectUrl: "/casino/aggappg-songkran-splash",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/songkransplash.webp",
        alt: "Songkran Splash",
        name: "Songkran Splash",
      },

      bakeryBonanza: {
        redirectUrl: "/casino/aggappg-bakery-bonanza",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/bakerybonanza.webp",
        alt: "Bakery Bonanza",
        name: "Bakery Bonanza",
      },

      hawaiianTiki: {
        redirectUrl: "/casino/aggappg-hawaiian-tiki",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/hawaiiantiki.webp",
        alt: "Hawaiian Tiki",
        name: "Hawaiian Tiki",
      },

      fortuneRabbit: {
        redirectUrl: "/casino/aggappg-fortune-rabbit",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/fortunerabbit.webp",
        alt: "Fortune Rabbit",
        name: "Fortune Rabbit",
      },

      midasFortune: {
        redirectUrl: "/casino/aggappg-midas-fortune",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/midasfortune.webp",
        alt: "Midas Fortune",
        name: "Midas Fortune",
      },

      asgardianRising: {
        redirectUrl: "/casino/aggappg-asgardian-rising",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/asgardianrising.webp",
        alt: "Asgardian Rising",
        name: "Asgardian Rising",
      },
        dinerDelights: {
        redirectUrl: "/casino/aggappg-diner-delights",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/dinerdelights.webp",
        alt: "Diner Delights",
        name: "Diner Delights",
      },

      alchemyGold: {
        redirectUrl: "/casino/aggappg-alchemy-gold",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/alchenygold.webp",
        alt: "Alchemy Gold",
        name: "Alchemy Gold",
      },

      totemWonders: {
        redirectUrl: "/casino/aggappg-totem-wonders",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/totemwinders.webp",
        alt: "Totem Wonders",
        name: "Totem Wonders",
      },

      prosperityFortuneTree: {
        redirectUrl: "/casino/aggappg-prosperity-fortune-tree",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/prosperityfortunes.webp",
        alt: "Prosperity Fortune Tree",
        name: "Prosperity Fortune Tree",
      },

      wildBountyShowdown: {
        redirectUrl: "/casino/aggappg-wild-bounty-showdown",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/wildbiuntyshowdown.webp",
        alt: "Wild Bounty Showdown",
        name: "Wild Bounty Showdown",
      },

      wildCoaster: {
        redirectUrl: "/casino/aggappg-wild-coaster",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "PGSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/alt-gaming/pgsoft/wildcoaster.webp",
        alt: "Wild Coaster",
        name: "Wild Coaster",
      },

      // legendOfPerseus: {
      //   redirectUrl: "/casino/aggappg-legend-of-perseus",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/legend-of-perseus.webp",
      //   alt: "Legend of Perseus",
      //   name: "Legend of Perseus",
      // },

      // speedWinner: {
      //   redirectUrl: "/casino/aggappg-speed-winner",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/speed-winner.webp",
      //   alt: "Speed Winner",
      //   name: "Speed Winner",
      // },

      // luckyPiggy: {
      //   redirectUrl: "/casino/aggappg-lucky-piggy",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/lucky-piggy.webp",
      //   alt: "Lucky Piggy",
      //   name: "Lucky Piggy",
      // },

      // winWinFishPrawnCrab: {
      //   redirectUrl: "/casino/aggappg-win-win-fish-prawn-crab",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/win-win-fish-prawn-crab.webp",
      //   alt: "Win Win Fish Prawn Crab",
      //   name: "Win Win Fish Prawn Crab",
      // },

      // battlegroundRoyale: {
      //   redirectUrl: "/casino/aggappg-battleground-royale",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/battleground-royale.webp",
      //   alt: "Battleground Royale",
      //   name: "Battleground Royale",
      // },

      // theQueensBanquet: {
      //   redirectUrl: "/casino/aggappg-the-queens-banquet",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/the-queens-banquet.webp",
      //   alt: "The Queen's Banquet",
      //   name: "The Queen's Banquet",
      // },

      // roosterRumble: {
      //   redirectUrl: "/casino/aggappg-rooster-rumble",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/rooster-rumble.webp",
      //   alt: "Rooster Rumble",
      //   name: "Rooster Rumble",
      // },

      // butterflyBlossom: {
      //   redirectUrl: "/casino/aggappg-butterfly-blossom",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/butterfly-blossom.webp",
      //   alt: "Butterfly Blossom",
      //   name: "Butterfly Blossom",
      // },

      // destinyOfSunAndMoon: {
      //   redirectUrl: "/casino/aggappg-destiny-of-sun-and-moon",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/destiny-of-sun-and-moon.webp",
      //   alt: "Destiny of sun and moon",
      //   name: "Destiny of sun and moon",
      // },

      // garudaGems: {
      //   redirectUrl: "/casino/aggappg-garuda-gems",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/garuda-gems.webp",
      //   alt: "Garuda Gems",
      //   name: "Garuda Gems",
      // },

      // fortuneTiger: {
      //   redirectUrl: "/casino/aggappg-fortune-tiger",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/fortune-tiger.webp",
      //   alt: "Fortune Tiger",
      //   name: "Fortune Tiger",
      // },
      //   orientalProsperity: {
      //   redirectUrl: "/casino/aggappg-oriental-prosperity",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/oriental-prosperity.webp",
      //   alt: "Oriental Prosperity",
      //   name: "Oriental Prosperity",
      // },

      // maskCarnival: {
      //   redirectUrl: "/casino/aggappg-mask-carnival",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/mask-carnival.webp",
      //   alt: "Mask Carnival",
      //   name: "Mask Carnival",
      // },

      // cocktailNights: {
      //   redirectUrl: "/casino/aggappg-cocktail-nights",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/cocktail-nights.webp",
      //   alt: "Cocktail Nights",
      //   name: "Cocktail Nights",
      // },

      // emojiRiches: {
      //   redirectUrl: "/casino/aggappg-emoji-riches",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/emoji-riches.webp",
      //   alt: "Emoji Riches",
      //   name: "Emoji Riches",
      // },

      // spiritedWonders: {
      //   redirectUrl: "/casino/aggappg-spirited-wonders",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/spirited-wonders.webp",
      //   alt: "Spirited Wonders",
      //   name: "Spirited Wonders",
      // },

      // legendaryMonkeyKing: {
      //   redirectUrl: "/casino/aggappg-legendary-monkey-king",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/legendary-monkey-king.webp",
      //   alt: "Legendary Monkey King",
      //   name: "Legendary Monkey King",
      // },

      // buffaloWin: {
      //   redirectUrl: "/casino/aggappg-buffalo-win",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/buffalo-win.webp",
      //   alt: "Buffalo Win",
      //   name: "Buffalo Win",
      // },

      // supermarketSpree: {
      //   redirectUrl: "/casino/aggappg-supermarket-spree",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/supermarket-spree.webp",
      //   alt: "Supermarket Spree",
      //   name: "Supermarket Spree",
      // },

      // raiderJanesCryptOfFortune: {
      //   redirectUrl: "/casino/aggappg-raider-janes-crypt-of-fortune",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/raider-janes-crypt-of-fortune.webp",
      //   alt: "Raider Jane's Crypt of Fortune",
      //   name: "Raider Jane's Crypt of Fortune",
      // },

      // mermaidRiches: {
      //   redirectUrl: "/casino/aggappg-mermaid-riches",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/mermaid-riches.webp",
      //   alt: "Mermaid Riches",
      //   name: "Mermaid Riches",
      // },

      // jurassicKingdom: {
      //   redirectUrl: "/casino/aggappg-jurassic-kingdom",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/jurassic-kingdom.webp",
      //   alt: "Jurassic Kingdom",
      //   name: "Jurassic Kingdom",
      // },

      // riseOfApollo: {
      //   redirectUrl: "/casino/aggappg-rise-of-apollo",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/rise-of-apollo.webp",
      //   alt: "Rise of Apollo",
      //   name: "Rise of Apollo",
      // },

      // heistStakes: {
      //   redirectUrl: "/casino/aggappg-heist-stakes",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/heist-stakes.webp",
      //   alt: "Heist Stakes",
      //   name: "Heist Stakes",
      // },

      // waysOfTheQilin: {
      //   redirectUrl: "/casino/aggappg-ways-of-the-qilin",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/ways-of-the-qilin.webp",
      //   alt: "Ways of the Qilin",
      //   name: "Ways of the Qilin",
      // },

      // wildBandito: {
      //   redirectUrl: "/casino/aggappg-wild-bandito",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/wild-bandito.webp",
      //   alt: "Wild Bandito",
      //   name: "Wild Bandito",
      // },

      // candyBonanza: {
      //   redirectUrl: "/casino/aggappg-candy-bonanza",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/candy-bonanza.webp",
      //   alt: "Candy Bonanza",
      //   name: "Candy Bonanza",
      // },

      // majesticTreasures: {
      //   redirectUrl: "/casino/aggappg-majestic-treasures",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/majestic-treasures.webp",
      //   alt: "Majestic Treasures",
      //   name: "Majestic Treasures",
      // },

      // cryptoGold: {
      //   redirectUrl: "/casino/aggappg-crypto-gold",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/crypto-gold.webp",
      //   alt: "Crypto Gold",
      //   name: "Crypto Gold",
      // },

      // baliVacation: {
      //   redirectUrl: "/casino/aggappg-bali-vacation",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/bali-vacation.webp",
      //   alt: "Bali Vacation",
      //   name: "Bali Vacation",
      // },

      // fortuneOx: {
      //   redirectUrl: "/casino/aggappg-fortune-ox",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/fortune-ox.webp",
      //   alt: "Fortune Ox",
      //   name: "Fortune Ox",
      // },

      // operaDynasty: {
      //   redirectUrl: "/casino/aggappg-opera-dynasty",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/opera-dynasty.webp",
      //   alt: "Opera Dynasty",
      //   name: "Opera Dynasty",
      // },

      // guardiansOfIceAndFire: {
      //   redirectUrl: "/casino/aggappg-guardians-of-ice-and-fire",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/guardians-of-ice-and-fire.webp",
      //   alt: "Guardians of Ice and Fire",
      //   name: "Guardians of Ice and Fire",
      // },

      // galacticGems: {
      //   redirectUrl: "/casino/aggappg-galactic-gems",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/galactic-gems.webp",
      //   alt: "Galactic Gems",
      //   name: "Galactic Gems",
      // },

      // jackFrostsWinter: {
      //   redirectUrl: "/casino/aggappg-jack-frosts-winter",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/jack-frosts-winter.webp",
      //   alt: "Jack Frost's Winter",
      //   name: "Jack Frost's Winter",
      // },

      // luckyNeko: {
      //   redirectUrl: "/casino/aggappg-lucky-neko",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/lucky-neko.webp",
      //   alt: "Lucky Neko",
      //   name: "Lucky Neko",
      // },

      // jewelsOfProsperity: {
      //   redirectUrl: "/casino/aggappg-jewels-of-prosperity",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/jewels-of-prosperity.webp",
      //   alt: "Jewels of Prosperity",
      //   name: "Jewels of Prosperity",
      // },

      // queenOfBounty: {
      //   redirectUrl: "/casino/aggappg-queen-of-bounty",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/queen-of-bounty.webp",
      //   alt: "Queen of Bounty",
      //   name: "Queen of Bounty",
      // },

      // vampiresCharm: {
      //   redirectUrl: "/casino/aggappg-vampires-charm",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/vampires-charm.webp",
      //   alt: "Vampire's Charm",
      //   name: "Vampire's Charm",
      // },

      // secretOfCleopatra: {
      //   redirectUrl: "/casino/aggappg-secret-of-cleopatra",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/secret-of-cleopatra.webp",
      //   alt: "Secret of Cleopatra",
      //   name: "Secret of Cleopatra",
      // },

      // thaiRiverWonders: {
      //   redirectUrl: "/casino/aggappg-thai-river-wonders",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/thai-river-wonders.webp",
      //   alt: "Thai River Wonders",
      //   name: "Thai River Wonders",
      // },

      // circusDelight: {
      //   redirectUrl: "/casino/aggappg-circus-delight",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/circus-delight.webp",
      //   alt: "Circus Delight",
      //   name: "Circus Delight",
      // },

      // treasuresOfAztec: {
      //   redirectUrl: "/casino/aggappg-treasures-of-aztec",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/treasures-of-aztec.webp",
      //   alt: "Treasures of Aztec",
      //   name: "Treasures of Aztec",
      // },

      // genies3Wishes: {
      //   redirectUrl: "/casino/aggappg-genies-3-wishes",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/genies-3-wishes.webp",
      //   alt: "Genie's 3 Wishes",
      //   name: "Genie's 3 Wishes",
      // },

      // wildFireworks: {
      //   redirectUrl: "/casino/aggappg-wild-fireworks",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/wild-fireworks.webp",
      //   alt: "Wild Fireworks",
      //   name: "Wild Fireworks",
      // },

      // dreamOfMacau: {
      //   redirectUrl: "/casino/aggappg-dream-of-macau",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/dream-of-macau.webp",
      //   alt: "Dream of Macau",
      //   name: "Dream of Macau",
      // },

      // phoenixRises: {
      //   redirectUrl: "/casino/aggappg-phoenix-rises",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/phoenix-rises.webp",
      //   alt: "Phoenix Rises",
      //   name: "Phoenix Rises",
      // },

      // ganeshaFortune: {
      //   redirectUrl: "/casino/aggappg-ganesha-fortune",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/ganesha-fortune.webp",
      //   alt: "Ganesha Fortune",
      //   name: "Ganesha Fortune",
      // },

      // egyptsBookOfMystery: {
      //   redirectUrl: "/casino/aggappg-egypts-book-of-mystery",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/egypts-book-of-mystery.webp",
      //   alt: "Egypt's Book of Mystery",
      //   name: "Egypt's Book of Mystery",
      // },

      // mahjongWays2: {
      //   redirectUrl: "/casino/aggappg-mahjong-ways-2",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/mahjong-ways-2.webp",
      //   alt: "Mahjong Ways 2",
      //   name: "Mahjong Ways 2",
      // },

      // bikiniParadise: {
      //   redirectUrl: "/casino/aggappg-bikini-paradise",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/bikini-paradise.webp",
      //   alt: "Bikini Paradise",
      //   name: "Bikini Paradise",
      // },

      // candyBurst: {
      //   redirectUrl: "/casino/aggappg-candy-burst",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/candy-burst.webp",
      //   alt: "Candy Burst",
      //   name: "Candy Burst",
      // },

      // caishenWins: {
      //   redirectUrl: "/casino/aggappg-caishen-wins",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/caishen-wins.webp",
      //   alt: "Caishen Wins",
      //   name: "Caishen Wins",
      // },

      // shaolinSoccer: {
      //   redirectUrl: "/casino/aggappg-shaolin-soccer",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/shaolin-soccer.webp",
      //   alt: "Shaolin Soccer",
      //   name: "Shaolin Soccer",
      // },

      // gemSaviourConquest: {
      //   redirectUrl: "/casino/aggappg-gem-saviour-conquest",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/gem-saviour-conquest.webp",
      //   alt: "Gem Saviour Conquest",
      //   name: "Gem Saviour Conquest",
      // },

      // reelLove: {
      //   redirectUrl: "/casino/aggappg-reel-love",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/reel-love.webp",
      //   alt: "Reel Love",
      //   name: "Reel Love",
      // },

      // fortuneMouse: {
      //   redirectUrl: "/casino/aggappg-fortune-mouse",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/fortune-mouse.webp",
      //   alt: "Fortune Mouse",
      //   name: "Fortune Mouse",
      // },

      // dragonHatch: {
      //   redirectUrl: "/casino/aggappg-dragon-hatch",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/dragon-hatch.webp",
      //   alt: "Dragon Hatch",
      //   name: "Dragon Hatch",
      // },

      // mahjongWays: {
      //   redirectUrl: "/casino/aggappg-mahjong-ways",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/mahjong-ways.webp",
      //   alt: "Mahjong Ways",
      //   name: "Mahjong Ways",
      // },

      // ninjaVsSamurai: {
      //   redirectUrl: "/casino/aggappg-ninja-vs-samurai",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/ninja-vs-samurai.webp",
      //   alt: "Ninja vs Samurai",
      //   name: "Ninja vs Samurai",
      // },

      // muayThaiChampion: {
      //   redirectUrl: "/casino/aggappg-muay-thai-champion",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/muay-thai-champion.webp",
      //   alt: "Muay Thai Champion",
      //   name: "Muay Thai Champion",
      // },

      // leprechaunRiches: {
      //   redirectUrl: "/casino/aggappg-leprechaun-riches",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/leprechaun-riches.webp",
      //   alt: "Leprechaun Riches",
      //   name: "Leprechaun Riches",
      // },

      // journeyToTheWealth: {
      //   redirectUrl: "/casino/aggappg-journey-to-the-wealth",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/journey-to-the-wealth.webp",
      //   alt: "Journey To The Wealth",
      //   name: "Journey To The Wealth",
      // },

      // flirtingScholar: {
      //   redirectUrl: "/casino/aggappg-flirting-scholar",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/flirting-scholar.webp",
      //   alt: "Flirting Scholar",
      //   name: "Flirting Scholar",
      // },

      // dragonTigerLuck: {
      //   redirectUrl: "/casino/aggappg-dragon-tiger-luck",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/dragon-tiger-luck.webp",
      //   alt: "Dragon Tiger Luck",
      //   name: "Dragon Tiger Luck",
      // },

      // captainsBounty: {
      //   redirectUrl: "/casino/aggappg-captains-bounty",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/captains-bounty.webp",
      //   alt: "Captains Bounty",
      //   name: "Captains Bounty",
      // },

      // theGreatIcescape: {
      //   redirectUrl: "/casino/aggappg-the-great-icescape",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/the-great-icescape.webp",
      //   alt: "The Great Icescape",
      //   name: "The Great Icescape",
      // },

      // doubleFortune: {
      //   redirectUrl: "/casino/aggappg-double-fortune",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/double-fortune.webp",
      //   alt: "Double Fortune",
      //   name: "Double Fortune",
      // },

      // emperorsFavour: {
      //   redirectUrl: "/casino/aggappg-emperors-favour",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/emperors-favour.webp",
      //   alt: "Emperors Favour",
      //   name: "Emperors Favour",
      // },

      // ganeshaGold: {
      //   redirectUrl: "/casino/aggappg-ganesha-gold",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/ganesha-gold.webp",
      //   alt: "Ganesha Gold",
      //   name: "Ganesha Gold",
      // },

      // symbolsOfEgypt: {
      //   redirectUrl: "/casino/aggappg-symbols-of-egypt",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/symbols-of-egypt.webp",
      //   alt: "Symbols of Egypt",
      //   name: "Symbols of Egypt",
      // },

      // jungleDelight: {
      //   redirectUrl: "/casino/aggappg-jungle-delight",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/jungle-delight.webp",
      //   alt: "Jungle Delight",
      //   name: "Jungle Delight",
      // },

      // piggyGold: {
      //   redirectUrl: "/casino/aggappg-piggy-gold",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/piggy-gold.webp",
      //   alt: "Piggy Gold",
      //   name: "Piggy Gold",
      // },

      // gemSaviourSword: {
      //   redirectUrl: "/casino/aggappg-gem-saviour-sword",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/gem-saviour-sword.webp",
      //   alt: "Gem Saviour Sword",
      //   name: "Gem Saviour Sword",
      // },

      // santasGiftRush: {
      //   redirectUrl: "/casino/aggappg-santas-gift-rush",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/santas-gift-rush.webp",
      //   alt: "Santa's Gift Rush",
      //   name: "Santa's Gift Rush",
      // },

      // prosperityLion: {
      //   redirectUrl: "/casino/aggappg-prosperity-lion",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/prosperity-lion.webp",
      //   alt: "Prosperity Lion",
      //   name: "Prosperity Lion",
      // },

      // mrHallowWin: {
      //   redirectUrl: "/casino/aggappg-mr-hallow-win",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/mr-hallow-win.webp",
      //   alt: "Mr. Hallow-Win",
      //   name: "Mr. Hallow-Win",
      // },

      // legendOfHouYi: {
      //   redirectUrl: "/casino/aggappg-legend-of-hou-yi",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/legend-of-hou-yi.webp",
      //   alt: "Legend of Hou Yi",
      //   name: "Legend of Hou Yi",
      // },

      // hipHopPanda: {
      //   redirectUrl: "/casino/aggappg-hip-hop-panda",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/hip-hop-panda.webp",
      //   alt: "Hip Hop Panda",
      //   name: "Hip Hop Panda",
      // },

      // dragonLegend: {
      //   redirectUrl: "/casino/aggappg-dragon-legend",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/dragon-legend.webp",
      //   alt: "Dragon Legend",
      //   name: "Dragon Legend",
      // },

      // hotpot: {
      //   redirectUrl: "/casino/aggappg-hotpot",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/hotpot.webp",
      //   alt: "Hotpot",
      //   name: "Hotpot",
      // },

      // treeOfFortune: {
      //   redirectUrl: "/casino/aggappg-tree-of-fortune",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/tree-of-fortune.webp",
      //   alt: "Tree of Fortune",
      //   name: "Tree of Fortune",
      // },

      // plushieFrenzy: {
      //   redirectUrl: "/casino/aggappg-plushie-frenzy",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/plushie-frenzy.webp",
      //   alt: "Plushie Frenzy",
      //   name: "Plushie Frenzy",
      // },

      // winWinWon: {
      //   redirectUrl: "/casino/aggappg-win-win-won",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/win-win-won.webp",
      //   alt: "Win Win Won",
      //   name: "Win Win Won",
      // },

      // hoodVsWolf: {
      //   redirectUrl: "/casino/aggappg-hood-vs-wolf",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/hood-vs-wolf.webp",
      //   alt: "Hood vs Wolf",
      //   name: "Hood vs Wolf",
      // },

      // medusa: {
      //   redirectUrl: "/casino/aggappg-medusa",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/medusa.webp",
      //   alt: "Medusa",
      //   name: "Medusa",
      // },

      // medusa2: {
      //   redirectUrl: "/casino/aggappg-medusa-2",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/medusa-2.webp",
      //   alt: "Medusa2",
      //   name: "Medusa2",
      // },

      // fortuneGods: {
      //   redirectUrl: "/casino/aggappg-fortune-gods",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/fortune-gods.webp",
      //   alt: "Fortune Gods",
      //   name: "Fortune Gods",
      // },

      // gemSaviour: {
      //   redirectUrl: "/casino/aggappg-gem-saviour",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/gem-saviour.webp",
      //   alt: "Gem Saviour",
      //   name: "Gem Saviour",
      // },

      // honeyTrapOfDiaoChan: {
      //   redirectUrl: "/casino/aggappg-honey-trap-of-diao-chan",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "PGSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/alt-gaming/pgsoft/honey-trap-of-diao-chan.webp",
      //   alt: "Honey Trap of Diao Chan",
      //   name: "Honey Trap of Diao Chan",
      // },
    }
};
